export default __webpack_public_path__ + "static/media/twitter.954ecc3e.svg";